import { Media } from "reactstrap";
import { ImageProps } from "../../Types/CommonElementType";

const Image: React.FC<ImageProps> = (props) => {
  return <Media {...props} alt={props.alt ? props.alt : "image"} loading="lazy"  />;
};

export default Image;
